import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const LockFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#ccc",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.11901 21H16.3739C17.7827 21 18.4929 20.2781 18.4929 18.7529V12.6171C18.4929 11.1035 17.7827 10.3816 16.3739 10.3816H8.11901C6.71022 10.3816 6 11.1035 6 12.6171V18.7529C6 20.2781 6.71022 21 8.11901 21ZM8.18888 19.4398C7.86287 19.4398 7.67657 19.2536 7.67657 18.8693V12.5006C7.67657 12.1164 7.86287 11.9418 8.18888 11.9418H16.304C16.6417 11.9418 16.8163 12.1164 16.8163 12.5006V18.8693C16.8163 19.2536 16.6417 19.4398 16.304 19.4398H8.18888ZM7.58344 11.185H9.2251V7.92497C9.2251 5.66623 10.6805 4.56016 12.2406 4.56016C13.8124 4.56016 15.2794 5.66623 15.2794 7.92497V11.185H16.9211V8.16947C16.9211 4.59507 14.5808 3 12.2406 3C9.91202 3 7.58344 4.59507 7.58344 8.16947V11.185Z"
        fill={color}
      />
    </svg>
  );
};

export { LockFilledSvg };
